import React, { Component, PropTypes } from 'react'
import { Panel } from 'react-bootstrap'
import WrappedPanelHeader from './WrappedPanelHeader'

class WrappedPanel extends Component {
  render () {
    // ...props is passed by PanelGroup of bootstrap
    // reference http://stackoverflow.com/questions/28906086/react-bootstrap-accordion-not-collapsing-with-map
    const {title, isValid, isOpened, children, isVisited, ...props} = this.props
    let header = (
      <WrappedPanelHeader
        title={title}
        isOpened={isOpened}
        isValid={isValid}
        isVisited={isVisited}
      />
    )
    return (
      <Panel
        onClick={this._onClickPanel}
        header={header}
        eventKey={this.props.eventKey}
        {...props}
        >
        {children}
      </Panel>
    )
  }

  _onClickPanel = () => {
    const {changeActiveKey, eventKey, isVisited} = this.props
    if (isVisited) {
      changeActiveKey(eventKey)
    }
  }
}

WrappedPanel.propTypes = {
  children: PropTypes.element,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  isValid: PropTypes.bool,
  isOpened: PropTypes.bool.isRequired,
  eventKey: PropTypes.string.isRequired,
  changeActiveKey: PropTypes.func.isRequired
}

export default WrappedPanel



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Program/WrappedPanel.js